var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getUploadCounter > 0)?_c('v-alert',{staticClass:"floating_top pulse",attrs:{"transition":"scroll-x-reverse-transition","type":"info","icon":"mdi-moon-full","color":"#292d39"}},[_vm._v(" Sauvegarde en cours ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }